import * as swcHelpers from '@swc/helpers';
import { mapServerToAccessoriesVariant } from '../variant-mappers/map-server-to-accessories-variant.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { mapServerToProductBase } from './map-server-to-product-base.js';

const mapServerToAccessoriesProduct = (serverProduct, slug, locale, facetConfigList, priceSegmentChannelKey)=>{
    if ((serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename) !== 'AccessoriesProduct') {
        return {
            failure: 'incorrect-typename',
            message: `Expected AccessoriesProduct for slug "${slug}", but got ${serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename}`
        };
    }
    const variants = mapServerToAccessoriesVariant(serverProduct, slug, locale, priceSegmentChannelKey);
    if (!variants || variants.length === 0) {
        return {
            failure: 'no-variants',
            message: `Cannot return Accessories product with slug: "${slug}" because it has no variants`
        };
    }
    return swcHelpers.objectSpread({}, mapServerToProductBase(serverProduct, variants, facetConfigList), {
        productType: 'Accessories',
        variants
    });
};

export { mapServerToAccessoriesProduct };
//# sourceMappingURL=map-server-to-accessories-product.js.map
